import Cookies from "js-cookie";

export default function Profile() {
  const users = JSON.parse(Cookies.get("user"));

  return (
    <>
      <div className="w-full items-center justify-center max-w-xxl bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
        <div className="flex justify-end px-4 pt-4">
          <button
            id="dropdownButton"
            data-dropdown-toggle="dropdown"
            className="inline-block text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm p-1.5"
            type="button"
          ></button>
          {/* Dropdown menu */}
        </div>
        <div className="flex flex-col items-center pb-10">
          <img
            className="w-24 h-24 mb-3 rounded-full shadow-lg"
            src={users.image_url}
            alt="Profile Image"
          />
          <h4 className="mb-1 text-xl font-medium text-gray-900 dark:text-white">
            {users.name}
          </h4>
          <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white">
            {users.email}
          </h5>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {Cookies.get("users.email")}
          </span>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            No ID : {users.id}
          </span>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            Created Account Date : {users.created_at}
          </span>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            Updated Account Date : {users.updated_at}
          </span>
          <div className="flex mt-4 space-x-3 md:mt-6">
            <a
              href="/dashboard/change-password"
              className="inline-flex items-center px-4 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              Change Password
            </a>
            <a
              href="/admin"
              className="inline-flex items-center px-4 py-2 text-sm font-medium text-center text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:ring-gray-700"
            >
              Dashboard
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
